import { Injectable } from '@angular/core';
import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs';
import { statusType } from '@datadog/browser-logs/bundle/datadog-logs';
import {environment} from '../environments/environment';
import {AuthService} from '@auth0/auth0-angular';

@Injectable({
  providedIn: 'root'
})
export class DatadogService {

  private user: any;
  //todo potentionally move this into our other apps for rum and datadog config
  private datadogConfig = {
    common: {
      clientToken: environment.datadog.clientToken,
      site: environment.datadog.site,
      service: environment.datadog.service,
    },
    logs: {
      forwardErrorsToLogs: true,
      forwardConsoleLogs: 'all', // Can also specify array ['log', 'debug', 'info', 'warn', 'error'],
      forwardReports: 'all', // Can also specify array ['intervention', 'deprecation', 'csp_violation']
      sampleRate: 10,
    },
    rum: {
      applicationId: environment.datadog.applicationId,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 100, // if not included, the default is 100
      trackResources: true,
      trackLongTasks: true,
      trackUserInteractions: true,
    }
  };
  constructor(private authService: AuthService) {
    if (!this.isLocalDevEnv()) {
      // enable real user monitoring for all non-local (deployed) environments
      datadogRum.init({
        ...this.datadogConfig.common,
        ...this.datadogConfig.rum,
        env: environment.name
      });
      // @ts-ignore because it doesn't recognize 'all'
      datadogLogs.init({
        ...this.datadogConfig.common,
        ...this.datadogConfig.logs,
        env: environment.name,
      });

      this.authService.user$.pipe().subscribe(user => {
        this.user = user;
        datadogRum.setUser({
          id: this.user.sub,
          email: this.user.email,
          sub: this.user.sub
        });
      });
    }
  }

  addRumAction(name: string, context?: object | undefined): void {
    if (this.isLocalDevEnv()) {
      datadogRum.addAction(name, context);
    }
  }

  addRumError(error: Error, context?: object | undefined): void {
    if (!this.isLocalDevEnv()) {
      datadogRum.addError(error, context);
    }
  }

  addRumTiming(name: string, time?: number | undefined): void {
    if (!this.isLocalDevEnv()) {
      datadogRum.addTiming(name, time || Date.now());
    }
  }

  getRumUser(): any | undefined {
    return this.user;
  }

  startSessionReplayRecording(): void {
    datadogRum.startSessionReplayRecording();
  }

  stopSessionReplayRecording(): void {
    datadogRum.stopSessionReplayRecording();
  }

  log(message: string, attributes, status: statusType = 'info'): void {
    if (!this.isLocalDevEnv()) {
      datadogLogs.logger.log(message, attributes, status);
    }
  }

  isLocalDevEnv() {
    return environment.name === 'local' || environment.name === 'dev';
    // return false;
  }
}
